<div class="footer-partners">
  <div class="footer-partners__title">
    <h4>Наши партнеры</h4>
  </div>
  <div class="footer-partners__carousel">
    <div class="pg-wrapper footer-partners__slide">
      <ng-container *ngFor="let partner of PartnersGalleryData">
        <div class="footer-partners__item pt-3 pb-3">
          <img src="{{partner.picture}}" alt="{{partner.title}}"/>
        </div>
      </ng-container>
    </div>
  </div>
</div>
